const LEAKED_TOOL_RESULTS = /<prior_tool_results>[\s\S]*?(?:<\/prior_tool_results>|$)/giu;

export const stripLeakedToolResults = (text: string): string => {
  if (!text.toLowerCase().includes('<prior_tool_results>')) return text;
  return text.replace(LEAKED_TOOL_RESULTS, '').replace(/\n{3,}/gu, '\n\n').trim();
};
